function submitStudentEntry(formFields, formId, formAlert) {
  return formHelpers
    .createFormData(formFields, formId)
    .then(function (formData) {
      return window.fetch("/student-design-challenge-application", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          data: formData,
          contacts: window.formTypeHelpers
            .getApplicants()
            .map(function (contact) {
              if (contact && contact.data) {
                return contact.data;
              }
            })
            .filter(Boolean),
        }),
      });
    })
    .then(function (response) {
      if (response.ok) {
        window.location = "/student-design-challenge-application/complete";
      } else {
        console.log(response);
        formAlert.innerHTML =
          "There was an issue processing this entry. Please contact us directly for more assistance.";
        document.querySelector("form.form").scrollIntoView();
        nextBtn.innerHTML = "Submit";
        nextBtn.disabled = false;
      }
    });
}

window.studentDesignFormHelpers = {
  submitStudentEntry: submitStudentEntry,
};
